export const MIND_YETI_ROUTES = {
  BASE_URL: '/product/mind-yeti',
  RESOURCES: {
    DEFAULT: '/',
    PLAYLIST: '/playlists',
  },
}
export function getStaticRoutes(path) {
  return [
    `${path}/program-supports`,
    `${path}/program-supports-k5`,
    `${path}/program-supports-el`,
    `${path}/resources`,
    `${path}/principal-toolkit`,
    `${path}/trainings`,
    `${path}/families`,
    `${path}/staff-training`,
    `${path}/program-training`,
    `${path}/advisory-activities`,
    `${path}/activities`,
    `${path}/learning-resources`,
    // the /admin route below is temporary and meant to sunset /sel-for-adults/leader-hub.
    // angie (or product) will let us know when they make a final decision on whether it will
    // supersede /leader-hub or be a new route entirely
    `${path}/admin`,
    `${path}/leader-hub`,
    `${path}/engage-families`,
    `${path}/accessibility`,
    `/product/k5-kit/teach`,
    `/product/bpu-kit/teach`,
    `/product/cpu-kit/teach`,
    `/product/el-kit/teach`,
    `/product/ms-kit/ms-teach`,
    `${MIND_YETI_ROUTES.BASE_URL}${MIND_YETI_ROUTES.RESOURCES.PLAYLIST}`,
    `/product/high-school/library`,
    `/product/high-school/training`,
    `/product/high-school/pathways`,
    `${path}/grades-k-1`,
    `${path}/grades-2-3`,
    `${path}/grades-4-5`,
  ]
}

export function getPagesV2StaticRoutesHighSchool() {
  return [
    '/product/high-school/program-supports',
    '/product/high-school/library',
    '/product/high-school/training',
    '/product/high-school/pathways',
    '/product/high-school/extension-activities',
  ]
}

export function getPagesV2StaticRoutesElementary() {
  return [
    '/product/elementary/activities',
    '/product/elementary/intervention-resources',
    '/product/elementary/trainings',
    '/product/elementary/program-supports',
    '/product/elementary/engage-families',
    '/product/elementary/tier-2-3-resources',
  ]
}

export function getPagesV2StaticRoutesMiddleSchool() {
  return [
    '/product/middle-school/advisory-activities',
    '/product/middle-school/trainings',
    '/product/middle-school/program-supports',
    '/product/middle-school/engage-families',
    '/product/middle-school/intervention-resources',
    '/product/middle-school/tier-2-3-resources',
  ]
}
